import React from 'react';
import { isEmpty } from 'lodash';

import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';

import { getStopType } from '../../common/routes';
import { getHumanReadableText } from '../../common/global';

import ACButton from '../../atoms/ACButton';

import styles from './Clue.module.scss';

export default class Clue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { provider = {}, clue = {}, notes = '', stopNumber = -1, stopType = '' } = this.props;

    if (isEmpty(provider) && isEmpty(clue)) return <div />;

    const providerName = provider.name || '';
    let stopTypeName = '';

    const findStopType = Object.values(getStopType()).find((sType) => {
      return sType === stopType;
    });

    if (!isEmpty(findStopType)) {
      stopTypeName = getHumanReadableText(findStopType);
    }
    return (
      <ListItem className={styles.root} onClick={this.props.onClickStopFunc}>
        <div className={styles.clue}>
          <div className={styles.mediumColumn}>{stopNumber}</div>
          <div className={styles.clueDetails}>
            <span className={styles.capitalizedBoldFont}>{providerName}</span>
          </div>
          <div className={styles.largeColumn}>
            <span
              style={{
                fontSize: '12px',
              }}
            >
              {notes}
            </span>
          </div>
          {!isEmpty(stopTypeName) ? (
            <Tooltip title={stopTypeName}>
              <div className={styles.mediumColumn}>
                <ACButton
                  text={stopTypeName}
                  backgroundColor={'#616161'}
                  spanMargin="0 0"
                  color={'white'}
                />
              </div>
            </Tooltip>
          ) : null}
        </div>
      </ListItem>
    );
  }
}
